import { type FC } from "react";

import { Checkbox } from "mds/components/Checkbox";
import { ListItem } from "mds/components/ListItem";
import { courseSelectors } from "store/selectors";
import { useObjectSelector } from "store/store-hooks";
import { getCourseDisplayTitle } from "utils/course";

type CourseAdminCourseItemProps = {
  courseId: string;
  isChecked: boolean;
  isDisabled?: boolean;
  onToggle: (courseId: string) => void;
};

export const CourseAdminCourseItem: FC<CourseAdminCourseItemProps> = ({
  courseId,
  isChecked,
  isDisabled = false,
  onToggle,
}) => {
  const course = useObjectSelector(
    (s) => courseSelectors.selectById(s, courseId),
    ["code", "title"],
  );

  if (!course) {
    return null;
  }

  return (
    <ListItem className="w-full gap-2">
      <Checkbox
        checked={isChecked}
        className="w-full"
        disabled={isDisabled}
        onChange={() => {
          if (!isDisabled) {
            onToggle(courseId);
          }
        }}
      >
        <span className="w-full">{getCourseDisplayTitle(course)}</span>
      </Checkbox>
    </ListItem>
  );
};
